export default "__VITE_ASSET__C5J3lNB8__"